import React from 'react';
import PropTypes from 'prop-types';

const PageTitle = ({text}) => {
    return <h1 className="text-center text-uppercase page-title">{text}</h1>;
};

PageTitle.propTypes = {
    text: PropTypes.string.isRequired
};

export default PageTitle;


// WEBPACK FOOTER //
// ./src/common/text/PageTitle.js